import React, { Component, useState } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import ReactDOM from 'react-dom'
import { Mobile, Desktop } from '../../../media'

import SelectBrokerDialog from './SelectBrokerDialog'
import BrokerPendingDialog from './BrokerPendingDialog'
import BrokerInfoSection from './BrokerInfoSection'

import ChevronDown from '../../../images/chevron_green.svg'
import ChevronUp from '../../../images/chevron_green_up.svg'
import InfoIcon from '../../../images/info.svg'
import ThunderIcon from '../../../images/thunder.svg'

import { connect } from "react-redux";
import { bindActionCreators } from 'redux'

import { actions as employeeActions } from '../../../actions/employee'
import { actions as maintenanceActions } from '../../../actions/maintenance'

import employeeService from '../../../services/Employee.service'
import {UserRoles} from '../../../constants'
import { addFlashMessageOfType } from 'redux-flash-messages'

import { history } from '../../../store'

import Accordion from '../../Accordion'


const Wrapper = styled.div`
    background-color: white;
    width: 288px;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    float: left;
    margin-right: 32px;

    // Mobile version.
    @media (max-width: 768px) {
        width: 100%;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    > div.pre-header {
        background: white;
        box-shadow: 0 -1px 0 0 #CCCCCC;

        > div {
            > div.current {
                padding: 10px 16px;
                background-color: white;
                font-family: Lato-Regular;
                font-size: 14px;
                color: #2B2B2B;
                text-align: left;
                line-height: 22px;;
                border: 1px solid #1CB548;
                margin-bottom: 29px;

                > img {
                    margin-right: 6px;
                    vertical-align: top;
                }

                > span.button-container {
                    float: right;

                    > button {
                        line-height: normal;
                    }
                }

                > div.inumber-container {
                    width: 100%;
                    padding-top: 3px;

                    > span.inumber-text {
                        font-weight: bold;
                    }
                }
            }
        }

        > button {
            margin: 15px;
            width: -moz-calc(100% - 30px);
            width: -webkit-calc(100% - 30px);
            width: -o-calc(100% - 30px);
            width: calc(100% - 30px);
            height: 43px;
        }

        > div.broker-warn {
            padding: 10px 16px;
            background-color: white;
            font-family: Lato-Regular;
            font-size: 14px;
            color: #2B2B2B;
            text-align: left;
            line-height: 22px;
            border: none;
            margin-bottom: 0px;

            > img {
                margin-right: 6px;
                vertical-align: top;
            }
        }
    }

    .desktop-broker-header {
        background-color: white;
        height: 94px;
        text-align: center;

        > img {
            margin: 0px auto;
            height: 94px;
        }
    }

    .desktop-broker-inner-header {
        margin-top: 0px;
        margin-bottom: 0px;
        background: rgb(237, 237, 237);
        border-bottom: 1px solid rgb(204, 204, 204);
        padding: 12px 15px 11px;
        font-family: Lato-Regular;
        font-size: 12px;
        color: rgb(102, 102, 102);
        text-align: left;
        text-transform: uppercase;
        line-height: 16px;
    }

    .broker-header.accordion-closed {
        background: url(${ChevronUp}) white;
        text-align: center;
        background-repeat: no-repeat;
        background-position-x: -moz-calc(100% - 15px);
        background-position-x: -webkit-calc(100% - 15px);
        background-position-x: -o-calc(100% - 15px);
        background-position-x: calc(100% - 15px);
        background-position-y: center;
        width: 100%;

        > img {
            margin: 0 auto;
            height: 94px;
        }
    }

    .broker-header.accordion-open {
        background: url(${ChevronDown}) white;
        text-align: center;
        background-repeat: no-repeat;
        background-position-x: -moz-calc(100% - 15px);
        background-position-x: -webkit-calc(100% - 15px);
        background-position-x: -o-calc(100% - 15px);
        background-position-x: calc(100% - 15px);
        background-position-y: center;
        width: 100%;

        > img {
            margin: 0 auto;
            height: 94px;
        }
    }

    .broker-sub-title.accordion-closed {
        margin-top: 0px;
        margin-bottom: 0px;
        background: url(${ChevronUp}) rgb(237, 237, 237);
        border-bottom: 1px solid rgb(204, 204, 204);
        padding: 12px 15px 11px;
        font-family: Lato-Regular;
        font-size: 12px;
        color: rgb(102, 102, 102);
        text-align: left;
        text-transform: uppercase;
        line-height: 16px;
        background-repeat: no-repeat;
        background-position-x: -moz-calc(100% - 15px);
        background-position-x: -webkit-calc(100% - 15px);
        background-position-x: -o-calc(100% - 15px);
        background-position-x: calc(100% - 15px);
        background-position-y: center;
        width: 100%;
    }

    .broker-sub-title.accordion-open {
        margin-top: 0px;
        margin-bottom: 0px;
        background: url(${ChevronDown}) rgb(237, 237, 237);
        border-bottom: 1px solid rgb(204, 204, 204);
        padding: 12px 15px 11px;
        font-family: Lato-Regular;
        font-size: 12px;
        color: rgb(102, 102, 102);
        text-align: left;
        text-transform: uppercase;
        line-height: 16px;
        background-repeat: no-repeat;
        background-position-x: -moz-calc(100% - 15px);
        background-position-x: -webkit-calc(100% - 15px);
        background-position-x: -o-calc(100% - 15px);
        background-position-x: calc(100% - 15px);
        background-position-y: center;
        width: 100%;
    }

    .broker-sub-content {
        font-family: Lato-Regular;
        font-size: 14px;
        color: rgb(43, 43, 43);
        text-align: left;
        line-height: 22px;
    }

    > footer {
        border-top: 1px solid #CCCCCC;
        margin: 0 15px;

        > a {
            display: block;
            width: auto;
            margin: 15px 0;

            font-family: Lato-Regular;
            font-size: 14px;
            text-decoration: none;

            color: #1D71BB;
            text-align: center;
            line-height: 16px;
        }
    }
`

class Broker extends Component {

    constructor(props) {
        super(props);

        this.state = {
            learnMoreDialogVisible: false,
            selectBrokerDialogVisible: false,
            brokerPendingDialogVisible: false,
            infoVisible: false
        }
    }

    componentDidMount() {
        const domNode = ReactDOM.findDOMNode(this);
        var headers = domNode.querySelectorAll('header[aria-expanded][aria-controls]');
        if( headers != null && headers.length > 0 ) {
            var be = new window.ButtonExpand(headers[0]);
            be.init();
        }
    }

    onButtonClickHandler = (isPendingBroker) => {
        if(isPendingBroker) {
            this.setState({
                brokerPendingDialogVisible: true
            })
        } else {
            this.setState({
                selectBrokerDialogVisible: true
            })
        }

    }

    selectLearnMoreHandler = () => {
        this.setState({
            learnMoreDialogVisible: true
        })
    }

    selectLearnMoreOnCloseDialog = () => {
        this.setState({
            learnMoreDialogVisible: false
        })
    }

    selectedBrokerHandler = (broker, openBlank) => {

        this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
          if(isLive) {
            this.props.actions.employee.changeBroker(broker.code).then(_ => {
                this.setState({
                    selectBrokerDialogVisible: false
                })

                addFlashMessageOfType("SUCCESS", 5000, this.props.t('AvailableBrokers.SuccessSelectingBroker'), null, null);

                var brokerUrl = employeeService.getBrokerUrl(broker, this.props.employee)
                if (brokerUrl != '#' && openBlank) {
                    window.open(brokerUrl, '_blank')
                }
              }).catch(_ => {
                this.setState({
                    selectBrokerDialogVisible: false
                })
                addFlashMessageOfType("ERROR", 5000, this.props.t('AvailableBrokers.FailedSelectingBroker'), null, null);
              })
          } else {
            history.push("/maintenance", {})
          }
        })

    }

    cancelBrokerHandler = (broker_code) => {


        this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
          if(isLive) {
            this.props.actions.employee.changeBroker(broker_code, true).then(_ => {
                this.setState({
                    brokerPendingDialogVisible: false
                })
                addFlashMessageOfType("SUCCESS", 5000, this.props.t('AvailableBrokers.SuccessCancelBroker'), null, null);

              }).catch(_ => {
                this.setState({
                    brokerPendingDialogVisible: false
                })
                addFlashMessageOfType("ERROR", 5000, this.props.t('AvailableBrokers.FailedCancelingBroker'), null, null);

              })
          } else {
            history.push("/maintenance", {})
          }
        })
    }

    selectBrokerOnCloseDialog = () => {
        this.setState({
            selectBrokerDialogVisible: false
        })
    }

    brokerPendingOnCloseDialog = () => {
        this.setState({
            brokerPendingDialogVisible: false
        })
    }

    toggleINumber = (data) => {
        // toggle the popup
        this.setState({
            infoVisible : !this.state.infoVisible
        });
    }

    render() {
        const { t, broker, broker_comparisons, employee} = this.props;
        const featured = broker_comparisons.filter(comparison => !!comparison.featured)
        var isCurrentBroker = employee.broker && employee.broker.code === broker.code
        var isPendingBroker = employee.pending_broker && employee.pending_broker.code === broker.code
        var isEmployeeDefaultBroker = employee.broker_change_status_cd === "D"
        var brokerDisabled = employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_DISABLE)
        var brokerChoiceAll = employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_ALL)
        var brokerChoiceNone = employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE)
        var viewOnly = employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_VIEW) ? true : false
        var showINumber = employee.fidelity_activated_in && (employee.broker_inumber && employee.broker_inumber !== '') && employee.W8W9_certification && (employee.broker && employee.broker.code === "FIDELITY")

        return (
            <Wrapper>

                <div className="pre-header">
                    {isCurrentBroker && !isEmployeeDefaultBroker &&
                        <React.Fragment>
                            <div>
                                <div className="current">
                                    <img alt="" src={InfoIcon}/>{t('AvailableBrokers.CurrentBrokerLabel')}
                                    {showINumber &&
                                        <span className="button-container">
                                            <button className='info-button secondary-button'
                                                aria-haspopup="true"
                                                aria-expanded={this.state.infoVisible}
                                                aria-controls="inumber-container"
                                                onClick={() => this.toggleINumber()}>
                                                    {t('AvailableBrokers.INumberLabel')}
                                            </button>
                                        </span>
                                    }
                                    <div role="region" id="inumber-container" className="inumber-container" style={{"display": this.state.infoVisible ? "block" : "none"}}>
                                        <span aria-describedby="inumber-description" aria-label={t('AvailableBrokers.INumberAriaLabel')} className="inumber-text">{employee.broker_inumber}</span><br/>
                                        <span id="inumber-description">{t('AvailableBrokers.INumberMessage')}</span>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    }

                    {!brokerChoiceNone && (!isCurrentBroker || isCurrentBroker && isEmployeeDefaultBroker) && !isPendingBroker &&
                        <React.Fragment>
                            {!brokerDisabled &&
                                <button
                                    className='secondary-button'
                                    onClick={() => this.onButtonClickHandler(false)}>
                                        {t('AvailableBrokers.SelectBrokerButton', {broker_name: broker.name})}
                                </button>
                            }
                            {brokerDisabled &&
                                <div>
                                    <div className="current"><img alt="" src={InfoIcon}/>{t('AvailableBrokers.BrokerDisabledMessage')}</div>
                                </div>
                            }
                        </React.Fragment>
                    }

                    {(!isCurrentBroker || isCurrentBroker && brokerChoiceAll && isEmployeeDefaultBroker) && isPendingBroker &&
                        <div className="broker-warn">
                            <img alt="" src={ThunderIcon}/>{t('AvailableBrokers.PendingElectionTitle')}&nbsp;
                            <a href="#/" className={brokerDisabled && 'disabled-link'} onClick={!brokerDisabled ? () => this.onButtonClickHandler(true) : null}>{t('AvailableBrokers.NextStepsLink')}</a>
                        </div>
                    }

                    {isCurrentBroker && brokerChoiceAll && isEmployeeDefaultBroker &&
                        <div className="broker-warn">
                            <img alt="" src={ThunderIcon}/>{t('AvailableBrokers.DefaultedBrokerTitle')}&nbsp;
                        </div>
                    }
                </div>

                <Mobile>
                    <Accordion
                        title={this.props.children}
                        titleClass="broker-header"
                        content={
                            <div>
                                {
                                    React.Children.toArray(
                                        featured.map((el, index) =>
                                            <Accordion
                                                key={index}
                                                title={<h2 className="accordian-inner-header" dangerouslySetInnerHTML={{ __html: el.title}}></h2>}
                                                content={<div dangerouslySetInnerHTML={{ __html: el.content}}></div>}
                                                titleClass="broker-sub-title"
                                                contentClass="broker-sub-content"
                                            />
                                        )
                                    )
                                }
                            </div>
                        }
                    />
                </Mobile>
                <Desktop>
                    <header className="desktop-broker-header">
                        {this.props.children}
                    </header>
                    <div>
                        {
                            React.Children.toArray(
                                featured.map((el, index) =>
                                    <div>
                                        <h2 className="desktop-broker-inner-header" dangerouslySetInnerHTML={{ __html: el.title}}></h2>
                                        <div className="broker-sub-content" dangerouslySetInnerHTML={{ __html: el.content}}></div>
                                    </div>
                                )
                            )
                        }
                    </div>
                </Desktop>

                <div />

                <footer>
                    <a href={broker.url2 ? broker.url2 : ''} target="_blank" >
                        {t('AvailableBrokers.GotoBrokerSiteButton', {broker_name: broker.name})}
                    </a>
                </footer>

                <SelectBrokerDialog
                    visible={this.state.selectBrokerDialogVisible}
                    onCloseDialog={this.selectBrokerOnCloseDialog}
                    onSelectedBroker={this.selectedBrokerHandler}
                    broker={broker}
                    viewOnly = {viewOnly}

                />
                <BrokerPendingDialog
                    visible={this.state.brokerPendingDialogVisible}
                    onCloseDialog={this.brokerPendingOnCloseDialog}
                    onSelectedBroker={this.cancelBrokerHandler}
                    broker={broker}
                    employee={employee}
                    viewOnly = {viewOnly}
                />
            </Wrapper>
        )
    }
}

const mapState = state => ({
    configuration_brokers: state.configuration.brokers,
    employee: state.employee
});

const mapDispatchToProps = dispatch => ({
    actions: {
      employee: bindActionCreators(employeeActions, dispatch),
      maintenance: bindActionCreators(maintenanceActions, dispatch),
    }
})

export default connect(mapState, mapDispatchToProps)(withTranslation('translations')(Broker));
